import React, {PropTypes as T} from 'react';
import './style';

export default class List extends React.Component {

    static propTypes = { 
        options: T.array.isRequired,
        template: T.func,
        onOptionSelected: T.func,
    };

    static defaultProps = { 
        onOptionSelected: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
            focussedOption: null,
        }
    }

    focusPrevious() {
        this.moveFocus(-1);
    }

    focusNext() {
        this.moveFocus(1);
    }

    selectFocussed() {
        if (!this.state.focussedOption) {
            return;
        }
        
        this.props.onOptionSelected(this.state.focussedOption);
    }

    moveFocus(upDown) {

        if (!this.props.options) {
            return;
        }

        var currentIndex = this.props.options.indexOf(this.state.focussedOption); //returns -1 if no option focussed :)

        var newIndex = currentIndex + upDown;

        //new index is out of bounds
        if (newIndex < 0 || newIndex > (this.props.options.length - 1))
        {
            return;
        }

        this.setState({ 
            focussedOption: this.props.options[newIndex],
        });

    }


    handleOptionClicked(option) {
        this.props.onOptionSelected(option);
    }

    renderOption(option) {

        if (this.props.template)
        {
            return this.props.template(option);
        }

        return option.toString();
    }

    getIdentityKey(tag) {

        if (this.props.identityKey)
        {
            return tag[this.props.identityKey];
        }
        else if (tag.id)
        {
            return tag.id;
        }
        else if (tag.guid)
        {
            return tag.guid;
        }
        else
        {
            return this.props.options.findIndex(r => r === tag);
        }

    }

	render() {

        return (
            <ul className="b3-select-list">

                {this.props.options.map(o => 

                    <li key={this.getIdentityKey(o)} onClick={this.handleOptionClicked.bind(this, o)} className={o == this.state.focussedOption ? "b3-select-focussed" : "" }>{this.renderOption(o)}</li>

                )}

            </ul>
        )
	}
}


// WEBPACK FOOTER //
// ./app/b3/select/List.js